'use client'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import type { ReactNode } from 'react'
import type { GapSize } from './FlexRow'

const gapMap: Record<GapSize, number> = {
  none: 0,
  xs: 0.5,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
}

interface PageContainerProps {
  children: ReactNode
  maxWidth?: number | string
  /** When set, children are stacked vertically with this gap. */
  gap?: GapSize
}

export default function PageContainer({
  children,
  maxWidth = '100%',
  gap,
}: PageContainerProps) {
  return (
    <Box
      component="main"
      sx={{
        p: 3,
        maxWidth,
        width: '100%',
        minHeight: '100%',
      }}
    >
      {gap ? <Stack spacing={gapMap[gap]}>{children}</Stack> : children}
    </Box>
  )
}
